import { arrangeZIndexes } from './arrange-z-indexes.js';

/**
 * bring the specified item to the front of the dynamically positioned items
 */
function bringItemToFront(draftPageEntry, draftItemEntry) {
  draftItemEntry.zIndex = Infinity;
  arrangeZIndexes(draftPageEntry);
}

export { bringItemToFront };
//# sourceMappingURL=bring-item-to-front.js.map
